import { useNuxtApp } from '#app'

export const state = () => ({
  query: ``,
  declarations: {
    name: ``,
    code: ``,
    declarations: [],
    under_eighteen: false,
    legal_guardian_name: null
  },
})

export const getters = {
  declarations: (state, url) => state.declarations,
}

export const mutations = {
  setDeclarations(state, declarations) {
    state.declarations = declarations
  }
}

function isExternal() {
  const { store } = useNuxtApp().nuxt2Context
  return store.getters[`permissions/userIsExternal`]
}

export const actions = {
  async getDeclarations({ commit }, { code, uuid, lang = undefined }) {
    let data
    if (isExternal()) {
      data = await this.$api.daSignerExternal.getDeclarations(code, uuid, lang)
    } else {
      data = await this.$api.daSigner.getDeclarations(code, uuid)
    }
    commit(`setDeclarations`, data)
  },

  async generateDA({ commit }, { data, uuid, lang = undefined }) {
    if (isExternal()) {
      return await this.$api.daSignerExternal.generateDA(data, uuid, lang)
    }
    return await this.$api.daSigner.generateDA(data, uuid)
  },

  async sendSignature({ commit }, { data }) {
    return await this.$api.daSignerExternal.sendSignature(data)
  },

  async getSignature({ commit }, { data }) {
    return await this.$api.daSignerExternal.getSignature(data)
  }
}
